import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MunilyTabItem } from './tabs.types';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent {
  @Input() tabs: MunilyTabItem[] = [];
  @Input() showBadge = true;
  @Input() selectedIndex = 0;

  @Output() tabChanged = new EventEmitter<number>();
  @Output() selectedIndexChange = new EventEmitter<number>();

  onSelectedIndexChange(index: number): void {
    this.selectedIndexChange.emit(index);
    this.tabChanged.emit(index);
  }
}
